import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'app-drivers',
    templateUrl: './drivers.component.html',
    styleUrls: ['./drivers.component.css'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class DriversComponent implements OnInit
{
  ngOnInit() {
    this.selected = "drivers_dashboard";
  }

  public selected: string;

  public select(name: string) {
    this.selected = name;
  }

  public isSelected(name: string) {
    return name == this.selected;
  }

}

